import {
  AiChatModelsResponse,
  CreateAiChatModelResponse,
  TAIChatModel,
} from '../types/chat-ai-models';
import http from '../utils/http-common';

const createAiChatModel = (data: TAIChatModel) => {
  return http.post<CreateAiChatModelResponse>(
    '/admin/ai-model/create-model',
    data
  );
};

const getAiModelById = (id: string) => {
  return http.post<CreateAiChatModelResponse>('/admin/ai-model/get-model', {
    modelId: id,
  });
};

const getAll = (filterAllActive?: boolean) => {
  return http.post<AiChatModelsResponse>('/admin/ai-model/get-models', { filterAllActive });
};


const updateAiChatModel = (data: TAIChatModel) => {
  return http.put<CreateAiChatModelResponse>(
    '/admin/ai-model/update-model',
    data
  );
};

const AiChatModelService = {
  createAiChatModel,
  getAiModelById,
  getAll,
  updateAiChatModel,
};

export default AiChatModelService;
